import React, { useState, useEffect } from 'react';
import { db } from '../../firebase';
import { collection, query, onSnapshot, where } from "firebase/firestore";
import { motion, AnimatePresence } from 'framer-motion';

const StudentActivityMonitor = () => {
    const [students, setStudents] = useState([]);

    const sendWhatsAppAlert = (parentPhone, studentName) => {
        const cleanPhone = parentPhone ? parentPhone.replace(/\D/g, '') : '';
        const formattedPhone = cleanPhone.startsWith('0') ? '964' + cleanPhone.slice(1) : cleanPhone;
        const message = `تنبيه من منصة نور أكاديمي: عزيزي ولي أمر الطالب ${studentName}، نود إعلامكم بأن الطالب حالياً مشتت التركيز عن المحاضرة. ⚠️`;
        const url = `https://wa.me/${formattedPhone}?text=${encodeURIComponent(message)}`;
        window.open(url, '_blank');
    };

    useEffect(() => {
        const q = query(collection(db, "users"), where("role", "==", "student"));
        const unsubscribe = onSnapshot(q, (snapshot) => {
            const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            // الترتيب الذكي: المشتتون دائماً في الأعلى (عشان الأستاذ يلحگهم)
            setStudents(data.sort((a, b) => (a.isFocused === false ? -1 : 1)));
        });
        return () => unsubscribe();
    }, []);

    return (
        <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="ios-glass p-6 rounded-[35px] border border-white/40 shadow-2xl bg-white/60 backdrop-blur-2xl w-full"
            style={{ fontFamily: "'Cairo', sans-serif" }}
        >
            {/* عنوان البطاقة الملكي */}
            <div className="flex justify-between items-center mb-6 px-2">
                <h3 className="text-[18px] font-black text-gray-800">مراقبة النشاط الحي 📡</h3>
                <div className="flex items-center gap-2">
                    <span className="w-2.5 h-2.5 rounded-full bg-emerald-500 animate-pulse"></span>
                    <span className="text-[11px] font-black text-gray-500 uppercase">LIVE</span>
                </div>
            </div>
            
            {/* القائمة التفاعلية */}
            <div className="space-y-3 max-h-[350px] overflow-y-auto custom-scroll pr-1">
                <AnimatePresence>
                    {students.filter(s => s.status === 'active').map((student) => (
                        <motion.div 
                            key={student.id}
                            initial={{ opacity: 0, x: -10 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: 10 }}
                            className={`flex items-center justify-between p-4 rounded-3xl border transition-all duration-300 ${
                                student.isFocused === false 
                                ? 'bg-red-50/80 border-red-200 shadow-sm' 
                                : 'bg-white/50 border-white/30'
                            }`}
                        >
                            {/* بيانات الطالب */}
                            <div className="flex items-center gap-3">
                                <div className="w-10 h-10 rounded-2xl bg-[#007AFF]/10 flex items-center justify-center font-black text-[#007AFF]">
                                    {student.name ? student.name[0] : '?'}
                                </div>
                                <span className="font-black text-[13px] text-gray-800">{student.name}</span>
                            </div>

                            {/* حالة النشاط (تفاعلية) */}
                            {student.isFocused === false ? (
                                <button 
                                    onClick={() => sendWhatsAppAlert(student.parentPhone, student.name)}
                                    className="flex items-center gap-2 bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-2xl transition-all shadow-lg shadow-red-500/20 animate-pulse"
                                >
                                    <span className="text-[10px] font-black">تنبيه ولي الأمر 📱</span>
                                </button>
                            ) : (
                                <div className="text-[11px] font-black text-emerald-600 flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-500/10">
                                    <div className="w-2 h-2 rounded-full bg-emerald-500"></div>
                                    مركز ✓
                                </div>
                            )}
                        </motion.div>
                    ))}
                </AnimatePresence>
            </div>
        </motion.div>
    );
};

export default StudentActivityMonitor;